// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","609":"31664189","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"e74f6576ed536b31d3b3","532":"3b60e114ed7b15538c38","609":"dc5366db8bc703dc7f02","678":"bc02092c7bf463e3cf85","883":"127c0cece6a1ef3be46e"}[chunkId] + ".js";
};